import Icon from '@ant-design/icons';
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import { ReactComponent as FullscreenSvg } from '../../assets/fullscreen-icon.svg';

export const FullscreenIcon = (props: Partial<CustomIconComponentProps>): JSX.Element => {
  return <Icon component={FullscreenSvg} {...props} />;
};
